<template>
   <v-container class="mt-5">
   <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
  </v-overlay>
   <v-card
    class="mx-auto"
    max-width="800"
    outlined
    color="grey lighten-4"
   >
    <v-card-title class="font-weight-bold">用户资料信息</v-card-title>
    <v-divider color="orange"></v-divider>
      <v-list-item>
        <span style="min-width:150px;text-align: left;">姓名: </span>  <span class="pa-2" style="min-width:150px;text-align: left;">{{profile.Name}}</span>
      </v-list-item>
      <v-list-item >
        <span style="min-width:150px;text-align: left;">名字标识符: </span>  <span class="pa-2" style="min-width:150px;text-align: left;">{{profile.NameIdentifier}}</span>
      </v-list-item>
      <v-list-item>
          <span style="min-width:150px;text-align: left;">联系方式:  </span> <span class="pa-2" style="min-width:150px;text-align: left;">{{profile.Email}}</span>
      </v-list-item>
      <v-list-item>
        <span style="min-width:150px;text-align: left;">用户组:</span> <span class="pa-2" style="min-width:150px;text-align: left;">  {{groups.join(', ')}} </span>
      </v-list-item>
      <v-list-item>
         <span style="min-width:150px;text-align: left;">目录服务组: </span> <span class="pa-2" style="min-width:150px;text-align: left;">{{adGroups.join(', ')}} </span>
      </v-list-item>
       <v-list-item>
         <span style="min-width:150px;text-align: left;">角色: </span> <span class="pa-2" style="min-width:150px;text-align: left;">{{roles.join(', ')}} </span>
      </v-list-item>
   </v-card>
   </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: 'userProfile',
    data:()=>({
        profile : {},
        groups: [],
        adGroups: [],
        roles:[],
        isLoading: false
    }),
    computed: {
      ...mapGetters(["userProfile"])
    },
    async mounted(){
        if (!this.userProfile)
        {
            this.isLoading = true;
            await this.$store.dispatch('getUserProfile');
            this.isLoading = false;
        }
        this.profile = this.userProfile;
        this.groups = this.userProfile.UserGroups.map((o)=>{return o.Name});
        this.adGroups = this.userProfile.Groups;
        this.roles = this.userProfile.Roles;

    },

}

</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/management/UserProfile.vue